const SERVICE_TYPE_DEFINITIONS = [
  { canonical: 'Waste Disposal', translationKey: 'WASTE_DISPOSAL', aliases: ['Abfallentsorgung'] },
  { canonical: 'Meter Reading Service', translationKey: 'METER_READING_SERVICE', aliases: ['Ablesedienst'] },
  { canonical: 'Elevator', translationKey: 'ELEVATOR', aliases: ['Aufzug'] },
  { canonical: 'Property Developer', translationKey: 'PROPERTY_DEVELOPER', aliases: ['Bauträger'] },
  { canonical: 'Coating (UG)', translationKey: 'COATING_UG', aliases: ['Beschichtung (TG)'] },
  { canonical: 'Fire Alarm System', translationKey: 'FIRE_ALARM_SYSTEM', aliases: ['Brandmeldeanlage'] },
  { canonical: 'Fire Doors', translationKey: 'FIRE_DOORS', aliases: ['Brandschutztüren'] },
  { canonical: 'Double Parker', translationKey: 'DOUBLE_PARKER', aliases: ['Doppelparker'] },
  { canonical: 'Energy Supply', translationKey: 'ENERGY_SUPPLY', aliases: ['Energieversorgung'] },
  { canonical: 'Electrical', translationKey: 'ELECTRICAL', aliases: ['Elektrik'] },
  { canonical: 'District Heating Supplier', translationKey: 'DISTRICT_HEATING_SUPPLIER', aliases: ['Fernwärmeversorger', 'Fernwärmelieferant'] },
  { canonical: 'Windows', translationKey: 'WINDOWS', aliases: ['Fenster'] },
  { canonical: 'Fire Extinguisher', translationKey: 'FIRE_EXTINGUISHER', aliases: ['Feuerlöscher'] },
  { canonical: 'Garage Door', translationKey: 'GARAGE_DOOR', aliases: ['Garagentor'] },
  { canonical: 'Garden Maintenance', translationKey: 'GARDEN_MAINTENANCE', aliases: ['Gartenpflege'] },
  { canonical: 'Gas Emergency/Gas Odor', translationKey: 'GAS_EMERGENCY_GAS_ODOR', aliases: ['Gas-Notdienst/Gasgeruch'] },
  { canonical: 'Gas Supply/Emergency Service', translationKey: 'GAS_SUPPLY_EMERGENCY_SERVICE', aliases: ['Gasversorgung/Störungsdienst'] },
  { canonical: 'Building Insurance', translationKey: 'BUILDING_INSURANCE', aliases: ['Gebäudeversicherung'] },
  { canonical: 'Fiber / Internet', translationKey: 'FIBER_INTERNET', aliases: ['Glasfaser / Internet'] },
  { canonical: 'Green Roof Maintenance', translationKey: 'GREEN_ROOF_MAINTENANCE', aliases: ['Gründachpflege'] },
  { canonical: 'Green Pruning', translationKey: 'GREEN_PRUNING', aliases: ['Grünschnitt'] },
  { canonical: 'Lifting Systems and Pumps', translationKey: 'LIFTING_SYSTEMS_AND_PUMPS', aliases: ['Hebeanlagen und Pumpen', 'Hebeanlagen und Pumpen'] },
  { canonical: 'Heating', translationKey: 'HEATING', aliases: ['Heizung'] },
  { canonical: 'Heating Cost Allocator', translationKey: 'HEATING_COST_ALLOCATOR', aliases: ['Heizkostenabrechner'] },
  { canonical: 'Heating Oil Supply', translationKey: 'HEATING_OIL_SUPPLY', aliases: ['Heizölversorgung'] },
  { canonical: 'Cable Television', translationKey: 'CABLE_TELEVISION', aliases: ['Kabelfernsehen'] },
  { canonical: 'Sewer/Blockage', translationKey: 'SEWER_BLOCKAGE', aliases: ['Kanal-/verstopfung', 'Kanal-/Verstopfung'] },
  { canonical: 'Ventilation', translationKey: 'VENTILATION', aliases: ['Lüftung'] },
  { canonical: 'Rental Mat Service', translationKey: 'RENTAL_MAT_SERVICE', aliases: ['Mietmattenservice'] },
  { canonical: 'Local Heating Supplier', translationKey: 'LOCAL_HEATING_SUPPLIER', aliases: ['Nahwärmeversorger'] },
  { canonical: 'Electric Storage Heater', translationKey: 'ELECTRIC_STORAGE_HEATER', aliases: ['Nachtspeicherofen'] },
  { canonical: 'Police', translationKey: 'POLICE', aliases: ['Polizei'] },
  { canonical: 'Smoke and Heat Extraction System', translationKey: 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM', aliases: ['Rauch- und Wärmeabzugsanlage'] },
  { canonical: 'Pipe Blockage', translationKey: 'PIPE_BLOCKAGE', aliases: ['Rohrverstopfung'] },
  { canonical: 'Pipe Burst & Water Damage', translationKey: 'PIPE_BURST_WATER_DAMAGE', aliases: ['Rohrbruch & Wasserschaden'] },
  { canonical: 'Smoke Detector', translationKey: 'SMOKE_DETECTOR', aliases: ['Rauchwarnmelder', 'Rauchmelder'] },
  { canonical: 'Roller Shutter/Raffstore', translationKey: 'ROLLER_SHUTTER_RAFFSTORE', aliases: ['Rollo/Raffstore'] },
  { canonical: 'Sanitary', translationKey: 'SANITARY', aliases: ['Sanitär'] },
  { canonical: 'Pest Control', translationKey: 'PEST_CONTROL', aliases: ['Schädlingsbekämpfung'] },
  { canonical: 'Locksmith Service', translationKey: 'LOCKSMITH_SERVICE', aliases: ['Schlüsseldienst'] },
  { canonical: 'Locking System Maintenance', translationKey: 'LOCKING_SYSTEM_MAINTENANCE', aliases: ['Schließanlage'] },
  { canonical: 'Chimney Sweep', translationKey: 'CHIMNEY_SWEEP', aliases: ['Schornsteinfeger'] },
  { canonical: 'Solar System/PVA', translationKey: 'SOLAR_SYSTEM_PVA', aliases: ['Solaranlage/PVA'] },
  { canonical: 'Bulk Waste Collection', translationKey: 'BULK_WASTE_COLLECTION', aliases: ['Sperrmüllabholung'] },
  { canonical: 'Power Supply/Emergency Service', translationKey: 'POWER_SUPPLY_EMERGENCY_SERVICE', aliases: ['Stromversorger/Störungsdienst'] },
  { canonical: 'Gate/Gate Systems', translationKey: 'GATE_GATE_SYSTEMS', aliases: ['Tore/Toranlagen'] },
  { canonical: 'Street and Sidewalk Cleaning', translationKey: 'STREET_AND_SIDEWALK_CLEANING', aliases: ['Straßen- und Gehwegreinigung'] },
  { canonical: 'Stairwell Cleaning', translationKey: 'STAIRWELL_CLEANING', aliases: ['Treppenhausreinigung'] },
  { canonical: 'Doors', translationKey: 'DOORS', aliases: ['Türen'] },
  { canonical: 'Roofer', translationKey: 'ROOFER', aliases: ['Dachdecker'] },
  { canonical: 'Water Supply', translationKey: 'WATER_SUPPLY', aliases: ['Wasserversorgung'] },
  { canonical: 'WE Meter', translationKey: 'WE_METER', aliases: ['WE-Zähler'] },
  { canonical: 'Recyclable Waste Disposal', translationKey: 'RECYCLABLE_WASTE_DISPOSAL', aliases: ['Wertstoffentsorgung'] },
  { canonical: 'Winter Service', translationKey: 'WINTER_SERVICE', aliases: ['Winterdienst'] },
  { canonical: 'Apartment Transfer Station (DHW/Heating)', translationKey: 'APARTMENT_TRANSFER_STATION_DHW_HEATING', aliases: ['Wohnungsübergabestation (WW/ Hzg)'] },
] as const;

const SERVICE_TYPE_ALIAS_MAP = new Map<string, string>();

const normalizeLookupKey = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s*-\s*/g, '-');

SERVICE_TYPE_DEFINITIONS.forEach(({ canonical, aliases }) => {
  SERVICE_TYPE_ALIAS_MAP.set(normalizeLookupKey(canonical), canonical);
  aliases.forEach((alias) => {
    SERVICE_TYPE_ALIAS_MAP.set(normalizeLookupKey(alias), canonical);
  });
});

const SERVICE_TYPE_TRANSLATION_KEY_MAP = new Map<string, string>(
  SERVICE_TYPE_DEFINITIONS.map(({ canonical, translationKey }) => [canonical, translationKey])
);

export type ServiceTypeOption = {
  value: string;
  translationKey: string;
};

export const SERVICE_TYPE_OPTIONS: ServiceTypeOption[] = SERVICE_TYPE_DEFINITIONS.map(({ canonical, translationKey }) => ({
  value: canonical,
  translationKey
}));

export const normalizeServiceTypeValue = (value: string | null | undefined): string => {
  const trimmed = (value || '').trim();
  if (!trimmed) {
    return '';
  }

  return SERVICE_TYPE_ALIAS_MAP.get(normalizeLookupKey(trimmed)) || trimmed;
};

export const normalizeServiceTypes = (...inputs: Array<string | string[] | null | undefined>): string[] => {
  const normalized: string[] = [];
  const seen = new Set<string>();

  inputs.forEach((input) => {
    const values = Array.isArray(input) ? input : [input];
    values.forEach((value) => {
      const canonical = normalizeServiceTypeValue(value);
      if (!canonical || seen.has(canonical)) {
        return;
      }
      seen.add(canonical);
      normalized.push(canonical);
    });
  });

  return normalized;
};

export const getServiceTypes = (service: { serviceTypes?: string[] | null; serviceType?: string | null } | null | undefined): string[] =>
  normalizeServiceTypes(service?.serviceTypes, service?.serviceType);

export const getPrimaryServiceType = (service: { serviceTypes?: string[] | null; serviceType?: string | null } | null | undefined): string =>
  getServiceTypes(service)[0] || '';

export const getServiceTypeTranslationKey = (serviceType: string | null | undefined): string => {
  const canonical = normalizeServiceTypeValue(serviceType);
  return SERVICE_TYPE_TRANSLATION_KEY_MAP.get(canonical) || '';
};

export const serviceHasType = (
  service: { serviceTypes?: string[] | null; serviceType?: string | null } | null | undefined,
  serviceType: string | null | undefined
): boolean => {
  const normalizedType = normalizeServiceTypeValue(serviceType);
  return !!normalizedType && getServiceTypes(service).includes(normalizedType);
};

export const normalizeServiceContact = <T extends { serviceTypes?: string[] | null; serviceType?: string | null }>(service: T): T & { serviceTypes: string[]; serviceType: string } => {
  const serviceTypes = getServiceTypes(service);
  const explicitType = normalizeServiceTypeValue(service?.serviceType);
  return {
    ...service,
    serviceTypes,
    serviceType: explicitType || serviceTypes[0] || ''
  };
};
